module.exports = __webpack_public_path__ + "media/images/features/refund/icon-refund-fe37849677b6f3e22f59f89dac203eba.svg";